import React from 'react';
import PropTypes from 'prop-types';
import { withDayChange } from '../index';
import { connect } from 'react-redux';
import {
  Dimmer,
  Image,
  List,
  Loader,
  Segment,
  Button,
} from 'semantic-ui-react';
import { Error } from '../common/Error';
import { history, store } from '../../helpers';
import {
  projectActions,
  teamMemberActions,
  projectConnectActivityActions,
} from '../../actions';
import Strings from '../../common/Strings';
import '../Common.css';
import './Directory.css';
import '../projects/Projects.css';
import {
  getSidePanelDateSectionForProjectActivity,
  getSectionForTeamMemberList,
} from '../../helpers/ui';

const moment = require('moment');

class Directory extends React.Component {
  static renderRootEmpty() {
    const step1 = Strings.DIRECTORY.formatString(
      Strings.DIRECTORY.getStartedStep1,
      <b>1.</b>,
    );
    const step2 = Strings.DIRECTORY.formatString(
      Strings.DIRECTORY.getStartedStep2,
      <b>2.</b>,
    );
    const step3 = Strings.DIRECTORY.formatString(
      Strings.DIRECTORY.getStartedStep3,
      <b>3.</b>,
    );
    return (
      <div className="directory-empty-container">
        <Image
          className="directory-empty-image"
          src="/empty/directory_empty.png"
        />
        <p className="directory-empty-title">
          {Strings.DIRECTORY.noActiveContributors}
        </p>
        <div className="directory-get-started-container">
          <p className="directory-get-started-title">
            {Strings.DIRECTORY.getStartedTitle}
          </p>
          <p className="directory-get-started-body">
            {Strings.DIRECTORY.getStartedBody}
          </p>
          <p className="directory-get-started-step">{step1}</p>
          <p className="directory-get-started-step">{step2}</p>
          <p className="directory-get-started-step">{step3}</p>
        </div>
        <p className="directory-inactive-connections-title">
          {Strings.DIRECTORY.inactiveConnections}
        </p>
        <div className="directory-inactive-connections-divider" />
        <p className="directory-inactive-connections-body">
          {Strings.DIRECTORY.inactiveConnectionsBody}
        </p>
      </div>
    );
  }

  static renderSidePanelEmpty() {
    const step2 = Strings.DIRECTORY.formatString(
      Strings.DIRECTORY.activityEmptyBody2,
      <a href="#newProject" target="_self">
        {Strings.DIRECTORY.project}
      </a>,
    );
    return (
      <div className="directory-activity-empty-container">
        <Image
          className="directory-activity-empty-image"
          src="/empty/activity_empty.png"
        />
        <p className="directory-activity-empty-title">
          {Strings.DIRECTORY.activityEmptyTitle}
        </p>
        <p className="directory-activity-empty-body">
          {Strings.DIRECTORY.activityEmptyBody1}
        </p>
        <p className="directory-activity-empty-body">{step2}</p>
      </div>
    );
  }

  onClickTeamMember = teamMember => {
    history.push(`/directory/${teamMember.uid}`);
  };

  handlePagination = () => {
    this.props.dispatch(
      projectConnectActivityActions.fetchMoreProjectConnectActivity(),
    );
  };

  renderDirectoryContent() {
    const { isLoading, isFailed, teamMembers, projects } = this.props;

    if (isLoading) return null;

    if (isFailed) {
      return (
        <Error
          title={Strings.DIRECTORY.failedTitle}
          body={Strings.DIRECTORY.failedBody}
          buttonText={Strings.COMMON.tryAgain}
          buttonOnClick={() => {
            if (store.getState().uiState.isProjectsFailed) {
              this.props.dispatch(projectActions.fetchProjects());
            }
            if (store.getState().uiState.isTeamMembersFailed) {
              this.props.dispatch(teamMemberActions.fetchTeamMembers());
            }
          }}
        />
      );
    }

    if (teamMembers.length === 0) {
      return Directory.renderRootEmpty();
    }

    // TODO IMPROVE PERFORMANCE OF THESE LOOPS

    const activeProjectsMap = new Map();
    const pendingProjectsMap = new Map();

    projects.forEach(p => {
      p.teamMembers.forEach(t => {
        if (t.status === 'active') {
          const count = activeProjectsMap.get(t.email);
          if (count) {
            const newCount = count + 1;
            activeProjectsMap.set(t.email, newCount);
          } else {
            activeProjectsMap.set(t.email, 1);
          }
        } else if (t.status === 'invited') {
          const count = pendingProjectsMap.get(t.email);
          if (count) {
            const newCount = count + 1;
            pendingProjectsMap.set(t.email, newCount);
          } else {
            pendingProjectsMap.set(t.email, 1);
          }
        }
      });
    });

    const activeTeamMembers = teamMembers.filter(teamMember =>
      projects.find(p =>
        p.teamMembers.find(
          t =>
            (t.email === teamMember.email || t.uid === teamMember.uid) &&
            t.status !== 'disconnected',
        ),
      ),
    );

    const inactiveTeamMembers = teamMembers.filter(
      inactive =>
        !activeTeamMembers.find(
          active =>
            active.email === inactive.email || active.uid === inactive.uid,
        ),
    );

    let ActiveTeamMembersSection;
    let InactiveTeamMembersSection;

    if (activeTeamMembers.length > 0) {
      const ActiveTeamMembers = activeTeamMembers.map(
        (teamMember, index, array) => {
          const activeProjectsCount = activeProjectsMap.get(teamMember.email);
          const pendingProjectsCount = pendingProjectsMap.get(teamMember.email);

          const Section = getSectionForTeamMemberList(teamMember, index, array);

          return (
            <List.Item key={teamMember.email}>
              {Section}
              <div
                className="team-member-list-item"
                onClick={() => this.onClickTeamMember(teamMember)}
              >
                <div style={{ flexGrow: 1 }}>
                  <p className="team-member-list-item-text">
                    {teamMember.name || teamMember.email}
                  </p>
                </div>
                {activeProjectsCount && (
                  <div>
                    <div className="team-member-list-item-stats">
                      <Image
                        className="active-projects-image"
                        src="/icon/active_projects.svg"
                      />
                      <p className="active-projects-count">
                        {activeProjectsCount}
                      </p>
                    </div>
                  </div>
                )}
                {activeProjectsCount &&
                  pendingProjectsCount && (
                    <div className="team-member-list-item-divider" />
                  )}
                {pendingProjectsCount && (
                  <div className="team-member-list-item-stats">
                    <Image
                      className="pending-invite-image"
                      src="/icon/pending_invite.svg"
                    />
                    <p className="pending-invite-count">
                      {pendingProjectsCount}
                    </p>
                    <p className="pending-invites">
                      {Strings.DIRECTORY.pendingInvites}
                    </p>
                  </div>
                )}
              </div>
            </List.Item>
          );
        },
      );

      ActiveTeamMembersSection = (
        <div style={{ marginBottom: '2rem' }}>
          <p className="active-team-members-header">
            {Strings.DIRECTORY.activeTeamMembersHeader}
          </p>
          <List>{ActiveTeamMembers}</List>
        </div>
      );
    }

    if (inactiveTeamMembers.length > 0) {
      const InactiveTeamMembers = inactiveTeamMembers.map(
        (teamMember, index, array) => {
          const InactiveSection = getSectionForTeamMemberList(
            teamMember,
            index,
            array,
          );
          return (
            <List.Item key={teamMember.email}>
              {InactiveSection}
              <div
                className="team-member-list-item inactive-team-member-list-item"
                key={teamMember.email}
                onClick={() => this.onClickTeamMember(teamMember)}
              >
                <div style={{ flexGrow: 1 }}>
                  <p className="team-member-list-item-text team-member-list-item-text-disabled">
                    {teamMember.name || teamMember.email}
                  </p>
                </div>
              </div>
            </List.Item>
          );
        },
      );

      InactiveTeamMembersSection = (
        <div style={{ marginBottom: '2rem' }}>
          <p className="inactive-team-members-header">
            {Strings.DIRECTORY.inactiveConnections}
          </p>
          <div className="inactive-team-members-divider" />
          <p className="inactive-team-members-body">
            {Strings.DIRECTORY.inactiveConnectionsInfo}
          </p>
          <List>{InactiveTeamMembers}</List>
        </div>
      );
    }

    return (
      <div>
        {ActiveTeamMembersSection}
        {InactiveTeamMembersSection}
      </div>
    );
  }

  onDayChanged() {
    const { dispatch } = this.props;
    dispatch(projectConnectActivityActions.fetchProjectConnectActivity());
  }

  renderSidePanelActivity() {
    const {
      isLoading,
      isFailed,
      isActivityLoading,
      isActivityFailed,
      hasMore,
      isActivityLoadingMore,
      connectActivity,
    } = this.props;
    if (isLoading || isActivityLoading) return null;

    if (isFailed || isActivityFailed) {
      return (
        <Error
          title={Strings.PROJECTS.activityFailedTitle}
          body={Strings.PROJECTS.activityFailedBody}
          buttonText={Strings.COMMON.tryAgain}
          buttonOnClick={() => {
            if (store.getState().uiState.isProjectsFailed) {
              this.props.dispatch(projectActions.fetchProjects());
            }
            if (store.getState().uiState.isTeamMembersFailed) {
              this.props.dispatch(teamMemberActions.fetchTeamMembers());
            }
            if (isActivityFailed) {
              this.props.dispatch(
                projectConnectActivityActions.fetchProjectConnectActivity(),
              );
            }
          }}
        />
      );
    }
    if (connectActivity.length === 0) {
      return Directory.renderSidePanelEmpty();
    }

    const teamMemberMap = new Map();
    this.props.teamMembers.forEach(t => teamMemberMap.set(t.uid, t));

    const projectsMap = new Map();
    this.props.projects.forEach(p => projectsMap.set(p.id, p));
    const RecentConnectActivity = connectActivity
      .filter(activityEvent => projectsMap.get(activityEvent.projectId))
      .map((activityEvent, index, array) => {
        let userName = teamMemberMap.has(activityEvent.uid)
          ? teamMemberMap.get(activityEvent.uid).name
          : activityEvent.userEmail;
        if (!userName) userName = activityEvent.userEmail;
        const timestamp = moment(activityEvent.timestamp).format('h:mm A');
        const projectName = projectsMap.get(activityEvent.projectId).name;
        const eventType = activityEvent.type;
        const connectedText = Strings.DIRECTORY.formatString(
          eventType === 'connected'
            ? Strings.DIRECTORY.connectedTo
            : Strings.DIRECTORY.disconnectedFrom,
          projectName,
        );

        const connectionStyle = `recent-activity-connection-log ${
          eventType === 'connected'
            ? 'recent-activity-connection-log-connected'
            : 'recent-activity-connection-log-disconnected'
        }`;

        const DateSection = getSidePanelDateSectionForProjectActivity(
          activityEvent,
          index,
          array,
        );

        return (
          <List.Item
            className="recent-activity-list-item"
            key={activityEvent.id}
          >
            {DateSection}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <p className="recent-activity-list-item-name">{userName}</p>
              <p className="recent-activity-list-item-time">{timestamp}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <p className={connectionStyle}>
                {eventType === 'connected'
                  ? Strings.DIRECTORY.connected
                  : Strings.DIRECTORY.disconnected}
              </p>
              <p className="recent-activity-list-item-to">{connectedText}</p>
            </div>
          </List.Item>
        );
      });

    let LoadMoreButton;
    if (hasMore) {
      LoadMoreButton = (
        <Button
          id="load-more-button"
          className="common-light-button"
          loading={isActivityLoadingMore}
          onClick={() => this.handlePagination()}
        >
          {Strings.DIRECTORY.loadMoreActivity}
        </Button>
      );
    }

    return (
      <div className="recent-activity-container">
        <List>{RecentConnectActivity}</List>
        {LoadMoreButton}
      </div>
    );
  }

  render() {
    const { isLoading, isFailed, isActivityLoading } = this.props;
    return (
      <Segment basic className="directory-root">
        <Dimmer active={isLoading} inverted>
          <Loader inverted />
        </Dimmer>
        <div className="directory">
          <div className="common-top-panel">
            <h1 id="directory-title" className="common-top-panel-title">
              {Strings.DIRECTORY.activeTeam}
            </h1>
          </div>
          <div className="directory-content-wrapper">
            <div className="directory-content">
              {this.renderDirectoryContent()}
              {!isFailed && (
                <Image className="app-footer-logo" src="/circles-grey.png" />
              )}
            </div>
          </div>
        </div>
        <Segment basic className="common-side-panel">
          <Dimmer active={isActivityLoading} inverted>
            <Loader inverted />
          </Dimmer>
          <div className="common-top-panel">
            <h1 id="activity-title" className="common-side-panel-title">
              {Strings.DIRECTORY.activity}
            </h1>
          </div>
          <div className="directory-side-panel-content">
            {this.renderSidePanelActivity()}
          </div>
        </Segment>
      </Segment>
    );
  }
}

Directory.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isFailed: PropTypes.bool.isRequired,
  teamMembers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
  ).isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      teamMembers: PropTypes.arrayOf(
        PropTypes.shape({
          email: PropTypes.string.isRequired,
        }).isRequired,
      ),
    }),
  ).isRequired,
  isActivityLoading: PropTypes.bool.isRequired,
  isActivityFailed: PropTypes.bool.isRequired,
  connectActivity: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
      projectId: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

const mapStateToProps = state => ({
  isLoading:
    state.uiState.isProjectsLoading || state.uiState.isTeamMembersLoading,
  isFailed: state.uiState.isProjectsFailed || state.uiState.isTeamMembersFailed,
  teamMembers: state.teamMembers,
  projects: state.projects,
  isActivityLoading: state.uiState.isProjectsConnectActivityLoading,
  isActivityFailed: state.uiState.isProjectsConnectActivityFailed,
  hasMore: state.uiState.isProjectsConnectActivityHasMore,
  isActivityLoadingMore: state.uiState.isProjectsConnectActivityLoadingMore,
  connectActivity: state.projectConnectActivity,
});

export default connect(mapStateToProps)(withDayChange(Directory));



// WEBPACK FOOTER //
// ./src/components/directory/Directory.js